import { EndExportAction, FamilyTreeActionFn } from '../types';

export const endExportAction: FamilyTreeActionFn<EndExportAction> = (state) => {
  return {
    ...state,
    isExporting: false,
  };
};
